import { useState } from 'react';
import { Form, Button, Radio, DatePicker } from 'antd';
import { formatDUI, I18nt, numbersOnly } from 'utils';
import { InputText } from 'components/Inputs';
import InfoButton from 'components/InfoButton';
import validations from 'utils/validations/ExamenesLab';
import { AuthDocumentType } from 'utils/interfaces';
import BannerWithImage from 'components/BannerWithImage';
import styles from './ExamenesLab.module.less';
import { useExamenesLabCtx } from '../ExamenesLabContext';
import moment, { Moment } from 'moment';
interface ExamenesLabFormParams {
	authType: 'dui' | 'afiliado';
	dui?: string;
	afiliado?: string;
	fechaNacimiento: Moment;
}

export default function FormView() {
	const [form] = Form.useForm();
	const [disabled, setDisabled] = useState(true);
	const [authType, setAuthType] = useState<AuthDocumentType>('dui');
	const { onFormSubmit } = useExamenesLabCtx();

	const onValuesChange = (
		changedValues: ExamenesLabFormParams,
		allValues: ExamenesLabFormParams
	) => {
		if (changedValues.afiliado) {
			allValues.afiliado = numbersOnly(changedValues.afiliado).slice(0, 10);
		}

		if (changedValues.dui) {
			allValues.dui = formatDUI(changedValues.dui).slice(0, 10);
		}

		if (changedValues.authType) {
			setAuthType(changedValues.authType);
			allValues.dui = '';
			allValues.afiliado = '';
		}
		form.setFieldsValue(allValues);

		const values = form.getFieldsValue();
		const duiValid = values.dui && values.dui.length === 10;
		const afiliadoValid = values.afiliado && values.afiliado.length > 0;
		const isAuthValid = duiValid || afiliadoValid;
		const isDateValid = values.fechaNacimiento as Moment;
		if (isAuthValid && isDateValid) {
			setDisabled(false);
		} else {
			setDisabled(true);
		}
	};

	const onFinish = (data: ExamenesLabFormParams) => {
		onFormSubmit({
			dui: data.dui,
			idAfiliado: data.afiliado,
			fechaNacimiento: data.fechaNacimiento.format('YYYY-MM-DD'),
		});
		form.resetFields(['dui', 'afiliado', 'fechaNacimiento']);
	};

	const getAuthField = () => {
		if (authType === 'dui') {
			return (
				<>
					<InputText
						name='dui'
						inputMode='numeric'
						label='dui'
						placeholder='placeholder_dui'
						rules={validations.dui}
					/>
				</>
			);
		}

		return (
			<>
				<InfoButton image='carnet' />
				<InputText
					name='afiliado'
					inputMode='numeric'
					label='numero_de_afiliado'
					placeholder='placeholder_num_afiliado'
					rules={validations.afiliado}
				/>
			</>
		);
	};

	return (
		<section className={styles.consultaMedicamentos}>
			<BannerWithImage className={styles.background}>
				<div className={styles.wrapper}>
					<div className={styles.formHeader}>
						<h4 className={styles.centerDesktop}>
							{I18nt('consulta_los_resultados_de_tus_examenes')}
						</h4>
						<p className={styles.centerDesktop}>
							{I18nt('ingresa_con_tu_dui')}
						</p>
					</div>
					<div className={styles.formContainer}>
						<Form
							form={form}
							layout='vertical'
							onFinish={onFinish}
							validateTrigger='onBlur'
							onValuesChange={onValuesChange}
							initialValues={{ authType: 'dui' }}
						>
							<Form.Item
								label={I18nt('documento_de_identificacion')}
								name='authType'
							>
								<Radio.Group
									size='large'
									value={authType}
									buttonStyle='solid'
									optionType='button'
									className={styles.identificationBox}
								>
									<Radio.Button value='dui'>{I18nt('dui')}</Radio.Button>
									<Radio.Button value='afiliado'>
										{I18nt('numero_afiliado')}
									</Radio.Button>
								</Radio.Group>
							</Form.Item>

							{getAuthField()}

							<Form.Item
								name='fechaNacimiento'
								className={styles.datePicker}
								required
								label={I18nt('selecciona_tu_fecha_de_nacimiento')}
							>
								<DatePicker
									allowClear
									format='DD-MM-YYYY'
									className={styles.datePickert}
									placeholder={I18nt('elegir_fecha')}
									disabledDate={(current) => current.isAfter(moment())}
								/>
							</Form.Item>
							<Form.Item className='mt-16'>
								<Button
									loading={false}
									block
									type='primary'
									htmlType='submit'
									disabled={disabled}
								>
									{I18nt('siguiente')}
								</Button>
							</Form.Item>
						</Form>
					</div>
				</div>
			</BannerWithImage>
		</section>
	);
}
